import Breadcrumb from './breadcrumb';
import BreadcrumbItem from './breadcrumb-item';

Breadcrumb.BreadcrumbItem = BreadcrumbItem;

export default Breadcrumb;
